module.exports = __webpack_public_path__ + "img/edu-road-2.b49d9998.png";